import * as yup from "yup";

export const eventSchemaNew = yup
    .object({
        title: yup
            .string()
            .required("Il titolo è obbligatorio")
            .trim(),
        description: yup
            .string()
            .trim(),
        startDate: yup
            .date(),
        endDate: yup
            .date(),
        location: yup
            .string()
            .trim(),
        price: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? 0 : value),
        lat: yup
            .number()
            .transform((value, originalValue) =>
                originalValue.trim() === "" ? undefined : value
            ),
        long: yup
            .number()
            .transform((value, originalValue) =>
                originalValue.trim() === "" ? undefined : value
            ),
        contactEmail: yup
            .string()
            .email("Il formato della email non è corretto"),
        contactPhone: yup
            .string(),
        contactWebsite: yup
            .string()
            .url("Il formato dell'URL non è corretto"),
        mediaList: yup
            .array()
    });

export const editEventSchemaNew = yup
    .object({
        title: yup
            .string()
            .trim(),
        description: yup
            .string()
            .trim(),
        startDate: yup
            .date(),
        endDate: yup
            .date(),
        location: yup
            .string()
            .trim(),
        price: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? 0 : value),
        lat: yup
            .number()
            .transform((value, originalValue) =>
                originalValue.trim() === "" ? undefined : value
            ),
        long: yup
            .number()
            .transform((value, originalValue) =>
                originalValue.trim() === "" ? undefined : value
            ),
        contactEmail: yup
            .string(),
        contactPhone: yup
            .string(),
        contactWebsite: yup
            .string(),
        mediaList: yup
            .array()
    });

export const eventSchema = yup
    .object({
        title: yup
            .string()
            .required("Il titolo è obbligatorio")
            .trim(),
        description: yup
            .string()
            .trim(),
        date: yup
            .date(),
        place: yup
            .string()
            .trim(),
        price: yup
            .string()
            .trim(),
        position_lat: yup
            .string()
            .trim(),
        position_lng: yup
            .string()
            .trim(),
        contacts_email: yup
            .string()
            .email("Il formato della email non è corretto"),
        contacts_phone: yup
            .string(),
        contacts_website: yup
            .string()
            .url("Il formato dell'URL non è corretto"),
        image: yup
            .string()
            .trim()
    })
